import NavbarLinks from '@/app/db/navbar_links';
import { Dict } from '@/app/types/Dict';
import Button from '@/app/ui/nav/Button';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useNavigation } from '@/app/contexts/Navigation';
import useWindowSize from '@/app/hooks/useWindowSize';
import { lilita } from '@/app/ui/font';
import {
  AvailableLinks,
  LinkListProps,
} from '@/app/types/components/LinkListType';

const sections: AvailableLinks[] = [
  'hero',
  'coin',
  'nextgen',
  'findway',
  'roadmap',
  'tokenomics',
];

export default function LinkList({
  onMobileClick,
  className = '',
}: LinkListProps) {
  const { refs } = useNavigation();
  const [active, setActive] = useState<AvailableLinks>('hero');
  const { isMobile } = useWindowSize();

  useEffect(() => {
    const createObserver = (section: AvailableLinks) =>
      new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActive(section);
          }
        },
        { threshold: 0.8 },
      );
    const observers = sections.reduce(
      (acc, section) => ({ ...acc, [section]: createObserver(section) }),
      {},
    );
    const handleRefs = (
      refAction: (observer: IntersectionObserver, ref: HTMLDivElement) => void,
    ) =>
      sections.forEach((section) => {
        if (refs?.[section])
          refAction(
            observers[section as keyof typeof observers],
            refs[section],
          );
      });
    handleRefs((observer, ref) => observer.observe(ref));
    return () => {
      handleRefs((observer, ref) => observer.unobserve(ref));
    };
  }, [refs]);

  return (
    <>
      {NavbarLinks.map((item: Dict) => (
        <Button
          onClick={() => {
            if (refs) {
              const ref: HTMLDivElement | null | undefined =
                refs?.[item.refname as keyof typeof refs];
              if (ref) {
                ref.scrollIntoView({
                  behavior: 'smooth',
                });
              }
            }
            if (isMobile) {
              onMobileClick?.();
            }
          }}
          key={item.name}
          className={clsx(`${className} uppercase`, {
            'text-vivid-orange hover:text-vivid-orange':
              active === item.activeRef,
            'text-pale-blue-gray hover:text-ice-blue':
              active !== item.activeRef,
          })}
        >
          {item.name}
        </Button>
      ))}
      <a
        target="_blank"
        href="/pdf/gamster-whitepaper.pdf"
        className={`${lilita.className} mb-[34px] block w-full border-b border-t border-[rgba(106,138,170,0.50)] py-4 text-[18px] uppercase text-pale-blue-gray hover:text-vivid-orange lg:mb-0 lg:w-fit lg:border-none lg:py-0`}
      >
        Whitepaper
      </a>
    </>
  );
}
